import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ItemActionParamsModel } from '@views/secured/object/components/object/model/item-action-params.model';
import { ItemActionEnum } from '@views/secured/object/components/object/enums/item-action.enum';
import { ObjectDefinitionModel } from '@base/modules/rest/bbs-object/model/object-definition.model';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-master-data-card',
  templateUrl: './master-data-card.component.html',
  styleUrls: ['./master-data-card.component.scss'],
})
export class MasterDataCardComponent {
  @Input() item: any;
  @Input() isSelectable = false;
  @Input() isSelected: boolean;
  @Input() cardProperties: string[];
  @Input() objectDefinition: ObjectDefinitionModel;
  @Input() isItemsView: boolean;
  @Input() isEditMode: boolean;
  @Output() itemActionEvent = new EventEmitter<ItemActionParamsModel>();
  @ViewChild(MatCheckbox) checkbox: MatCheckbox;

  itemClick(): void {
    this.itemActionEvent.emit({action: ItemActionEnum.View, data: this.item});
  }

  deleteItem(): void {
    this.itemActionEvent.emit({action: ItemActionEnum.Delete, data: this.item});
  }
}
